import { Paper as MuiPaper } from "@mui/material";

interface PaperProps {
  children: React.ReactNode;
  sx?: any;
}

const Paper = ({ children, sx }: PaperProps) => <MuiPaper sx={{ mt: 4, p: 2, ...sx }}>{children}</MuiPaper>;

export default Paper;
